import * as React from 'react';
import TextField from 'material-ui/TextField/TextField';
import withStyles, { StyleRulesCallback } from 'material-ui/styles/withStyles';
import { ChangeEvent } from 'react';
import { CONSTANTS } from '../../assets/UIConstants';

interface Props {
    autofocus?: boolean;
    defaultValue?: string;
    value?: string;
    label?: string;
    classes?: ClassesList;
    placeholder?: string;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    id?: string;
    disabled?: boolean;
    error?: boolean;
    type?: string;
    style?: React.CSSProperties;
    fullWidth?: boolean;
}

interface ClassesList {
    textFieldRoot: string;
    textFieldInput: string;
    textFieldFormLabel: string;
}

const styles: StyleRulesCallback = theme => ({
    textFieldRoot: {
      padding: 0,
      'label + &': {
        marginTop: theme.spacing.unit * 4.5,
      },
      width: '100%'
    },
    textFieldInput: {
      borderRadius: 4,
      background: theme.palette.common.white,
      border: `1px solid ${CONSTANTS.COLORS.TEXT_INPUT_BORDER}`,
      fontSize: 16,
      padding: '10px 12px',
      width: 'calc(100% - 24px)',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      color: CONSTANTS.COLORS.SEARCH_GREY,
      fontWeight: 300,
      fontFamily: CONSTANTS.FONT_FAMILY,
      '&:focus': {
        borderColor: CONSTANTS.COLORS.TEXT_INPUT_BORDER_FOCUS,
        boxShadow: CONSTANTS.BOX_SHADOW.TEXT_INPUT,
      },
    },
    textFieldFormLabel: {
      fontSize: 18,
      paddingTop: 18,
      fontFamily: CONSTANTS.FONT_FAMILY,
      fontWeight: 300
    },
  });

export function CustomTextInput(props: Props): JSX.Element {

    const { classes } = props;
    
    return (
        <TextField
            defaultValue={props.defaultValue}
            value={props.value}
            label={props.label}
            InputProps={{
            disableUnderline: true,
            classes: {
                root: classes!.textFieldRoot,
                input: classes!.textFieldInput,
            },
            }}
            InputLabelProps={{
            shrink: true,
            className: classes!.textFieldFormLabel,
            }}
            placeholder={props.placeholder}
            onChange={props.onChange}
            id={props.id}
            disabled={props.disabled}
            error={props.error}
            autoFocus={props.autofocus}
            type={props.type}
            fullWidth={props.fullWidth}
        />
    );
}

export default withStyles(styles)(CustomTextInput);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/TextInput.tsx